<template>
  <div ref="scroll" class="pullup-wrapper">
    <div class="container">
      <div class="title">
        <h3 class="text">演练照片</h3>
      </div>
      <div class="searchContainer">
        <a-form>
          <a-row :gutter="6" class="searchBox">
            <a-col :span="8">
              <a-form-item>
                <a-select
                  @change="changeuniversity"
                  placeholder="单位"
                  v-model="university"
                  :disabled='disabled'
                >
                  <a-select-option
                    v-for="(item, key) in universitylist"
                    :key="key"
                    :value="item.id"
                  >
                    <span
                      style="display: inline-block; width: 100%"
                      :title="item.universityName"
                    >
                      {{ item.universityName }}
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
                <a-select placeholder="活动批次" v-model="actBatchCode">
                  <a-select-option :value="undefined">请选择</a-select-option>
                  <a-select-option
                    v-for="(item, key) in activecodelist"
                    :key="key"
                    :value="item"
                  >
                    <span
                      style="display: inline-block; width: 100%"
                      :title="item"
                    >
                      {{ item }}
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-button
                type="primary"
                @click="search"
                shape="round"
                icon="search"
                >查询</a-button
              >
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div v-for="(item, key) in picList" :key="key" v-show="item.length > 0">
        <div class="batchCode">{{ key }}</div>
        <div class="imgContainer">
          <img :src="imgBaseUrl + '/' + i.picUrl" v-for="i in item" :key="i.id" class="imgBox" :onerror="defaultImg" @click="viewPic(imgBaseUrl + '/' + i.picUrl)" />
        </div>
      </div>
      <div v-show="bool">
        <img src="../../assets/loading.png" class="loadingPic"/>
      </div>
      <!-- <div class="pullup-tips">
        <div v-if="!isPullUpLoad" class="before-trigger">
          <span class="pullup-txt">下拉加载更多</span>
        </div>
        <div v-else class="after-trigger">
          <span class="pullup-txt">Loading...</span>
        </div>
      </div> -->
    </div>
  </div>
</template>


<script>
import { getAction } from "@/api/manage";
import BScroll from "@better-scroll/core";
import Pullup from "@better-scroll/pull-up";
import Axios from "@/Axios";

BScroll.use(Pullup);

export default {
  data() {
    return {
      imgBaseUrl: window.network["imgUrl"],
      picList: [],
      isPullUpLoad: false,
      pageNo: 1,
      defaultImg: 'this.src="' + require("../../assets/loading.png") + '"',
      // university: localStorage.getItem('universityId_dictText') || undefined,
      // universityId: JSON.parse(localStorage.getItem('teacher_info')).universityId || '',
      university: undefined,
      universityId: '',
      actBatchCode: undefined,
      universitylist: [],
      activecode: undefined,
      activecodelist: [],
      disabled: true,
      bool: false,
    };
  },
  watch:{
    university:{
      handler(newVal,oldVal) {
		      this.getactivelist(this.universityId)
           this.search()
		  },
	    immediate: true
    }
  },
  created() {},
  mounted() {
    this.getPicList();
    this.initBscroll();
    this.getselectlist();
    this.getUniversityId()
    this.search()
  },
  methods: {
    getUniversityId() {
      if (localStorage.getItem('universityId_dictText')) {
        this.university = localStorage.getItem('universityId_dictText')
      }
      if (localStorage.getItem('teacher_info')) {
        this.universityId = JSON.parse(localStorage.getItem('teacher_info')).universityId
      }else {
        this.disabled = false
      }
    },
    search() {
      Axios.get("picture/yhaPicture/listPicByBatchAndSchool", {
        params: {
          universityId: this.universityId || '',
          // universityId: "1316922986225205249",
          actBatchCode: this.actBatchCode || "",
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.picList = res.data.result;
          for (var i in this.picList) {
            console.log(this.picList[i])
            if (this.picList[i].length > 0) {
              console.log(false)
              this.bool = false
              return
            }else {
              this.bool = true
            }
          }
        }
      });
    },
    // 活动编码置空
    clearactivelist() {
      this.activecodelist = [];
      this.activecode = undefined;
    },
    // 查询区域单位改变
    changeuniversity(val) {
      this.clearactivelist();
      this.universityId = val;
      this.actBatchCode = ''
      if (val) {
        this.getactivelist(val);
      }
    },
    // 通过单位id获取活动编码
    getactivelist(universityId) {
      let that = this;
      if (!universityId) {
        return;
      }
      Axios.get("/qrcode/yhaDigitalCode/activeCode", {
        params: {
          universityId: universityId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          that.activecodelist = res.data.result;
        }
      });
    },
    // 获取单位列表
    getselectlist() {
      let that = this;
      Axios.get("/university/yhaUniversity/list").then((res) => {
        if (res.data.code == 200) {
          that.universitylist = res.data.result.records;
          if (!localStorage.getItem('teacher_info')) {
            this.universityId = this.universitylist[0].id
            this.university = this.universitylist[0].universityName
          }
        }
      });
    },
    viewPic(urlx) {
      this.$success({
        content: (
          <img
            ref="cerimg"
            class="cerimg"
            src={urlx}
            alt
            style="max-width: 98vw; max-height: 60vh;"
          />
        ),
        closable: true,
        class: "vpClass",
        footer: null,
        maskClosable: true,
        autoFocusButton: null,
        okText: "",
        maskStyle: { background: "#000000" },
      });
    },
    initBscroll() {
      this.bscroll = new BScroll(this.$refs.scroll, {
        pullUpLoad: true,
        click: true,
      });

      this.bscroll.on("pullingUp", this.pullingUpHandler);
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true;

      await this.getPicList();

      this.bscroll.finishPullUp();
      this.bscroll.refresh();
      this.isPullUpLoad = false;
    },
    getPicList() {
      // let par = {
      //   pageNo: this.pageNo,
      //   pageSize: 30,
      // };
      // let tinfo = localStorage.getItem("teacher_info");
      // debugger;
      // if (tinfo) {
      //   par.universityId = JSON.parse(tinfo).universityId;
      // }
      // // if (this.$route.query && this.$route.query.universityId) {
      // //   par.universityId = this.$route.query.universityId;
      // // }

      // let that = this;
      // return getAction("/picture/yhaPicture/list", par).then((res) => {
      //   if (res.success) {
      //     that.picList = that.picList.concat(res.result.records);
      //     that.pageNo++;
      //     that.picList.map((item) => {
      //       item.itemPicUrl = window.network["imgUrl"] + "/" + item.picUrl;
      //     });
      //   }
      // });
      this.search();
    },
  },
};
</script>

<style scoped>
.loadingPic {
  width: 50%;
  position: fixed;
  top: 30%;
  left: 22%;
}
.batchCode {
  text-align: left;
  margin-bottom: 10px;
  margin-top: -3px;
}
.imgContainer {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
@media screen and (max-width: 768px) {
.imgBox {
  width: 21%;
  height: 60px;
  margin-bottom: 14px;
  margin-right: 14px;
}
}
@media screen and (min-width: 768px) {
.imgBox {
  width: 21%;
  height: 80px;
  margin-bottom: 14px;
  margin-right: 14px;
}
}
.ant-form-item {
  margin-bottom: 0px;
}
.searchContainer {
  margin-bottom: 20px;
}
.searchBox {
  display: flex;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .container {
    width: 50%;
    margin: 0 auto;
  }
}
.pullup-wrapper {
  height: 100%;
  padding-left: 14px;
  border: 1px solid #ccc;
  overflow: hidden;
}

.more {
  margin-left: auto;
  color: #999999;
  font-size: 15px;
  display: flex;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5vw;
}
@media screen and (min-width: 768px) {
  .title {
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -50px;
    margin-top: 30px;
  }
}
.titleicon {
  background-color: #ff6347;
  color: white;
  display: inline-block;
  width: 6vw;
  height: 6vw;
  line-height: 6vw;
  border-radius: 1vw;
}
.icon {
  width: 24px;
  height: 24px;
  margin-right: 2vw;
}
.icon img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/morePic/morePic.vue